import { createSlice } from "@reduxjs/toolkit";

import { fetchEntityActivity, fetchOwnerActivity } from "./actions";

export const initialState = {
  owner: {},
  entity: {},
};

const EMPTY_TARGET = { rows: [], offset: 0, pageSize: 50, total: 0, isLoading: false, error: null };

const handlePending = (bucket, key) => {
  if (!bucket[key]) {
    bucket[key] = { ...EMPTY_TARGET };
  }
  bucket[key].isLoading = true;
  bucket[key].error = null;
};

const handleFulfilled = (bucket, key, response) => {
  const existing = bucket[key] ?? { ...EMPTY_TARGET };
  const isFirstPage = response.offset === 0;
  bucket[key] = {
    rows: isFirstPage ? response.rows : [...existing.rows, ...response.rows],
    offset: response.offset,
    pageSize: response.pageSize,
    total: response.total,
    isLoading: false,
    error: null,
  };
};

const handleRejected = (bucket, key, error) => {
  if (!bucket[key]) {
    bucket[key] = { ...EMPTY_TARGET };
  }
  bucket[key].isLoading = false;
  bucket[key].error = error?.message ?? "Failed to load activity";
};

const activityLogSlice = createSlice({
  name: "activityLog",
  initialState,
  reducers: {
    resetTarget: (state, action) => {
      const { kind, key } = action.payload;
      delete state[kind][key];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOwnerActivity.pending, (state, action) => {
        handlePending(state.owner, `${action.meta.arg.ownerType}:${action.meta.arg.ownerId}`);
      })
      .addCase(fetchOwnerActivity.fulfilled, (state, action) => {
        handleFulfilled(state.owner, action.payload.key, action.payload.response);
      })
      .addCase(fetchOwnerActivity.rejected, (state, action) => {
        handleRejected(state.owner, `${action.meta.arg.ownerType}:${action.meta.arg.ownerId}`, action.error);
      })
      .addCase(fetchEntityActivity.pending, (state, action) => {
        handlePending(state.entity, `${action.meta.arg.entityType}:${action.meta.arg.entityId}`);
      })
      .addCase(fetchEntityActivity.fulfilled, (state, action) => {
        handleFulfilled(state.entity, action.payload.key, action.payload.response);
      })
      .addCase(fetchEntityActivity.rejected, (state, action) => {
        handleRejected(state.entity, `${action.meta.arg.entityType}:${action.meta.arg.entityId}`, action.error);
      });
  },
});

export const { resetTarget } = activityLogSlice.actions;
export default activityLogSlice.reducer;
